import * as React from "react";
import { useEffect, useState } from "react";
import { CmsApi } from "api/CmsApi";
import { useLocale } from "components/LocaleContext";
import { AppPath } from "components/AppPath";
import * as Router from "react-router-dom";

export const useLocalizedGuidePage = (unlocalizedSlug: string): string => {
  const userLocale = useLocale();
  const unlocalizedPath = Router.generatePath(AppPath.GUIDES, {
    guidePageSlug: unlocalizedSlug,
  });
  const [guidePathPath, setGuidePagePath] = useState(unlocalizedPath);

  useEffect(() => {
    CmsApi.instance.getGuidePage(unlocalizedSlug).then((page) => {
      if (page === undefined) {
        return;
      }

      if (page.attributes.locale !== userLocale) {
        const moreAppropriatePage = page.attributes.localizations.data.find(
          (localization) => {
            return (
              localization.attributes.locale.split("-")[0] ===
              userLocale.split("-")[0]
            );
          }
        );

        if (moreAppropriatePage !== undefined) {
          const localizedPath = Router.generatePath(AppPath.GUIDES, {
            guidePageSlug: moreAppropriatePage.attributes.slug,
          });
          setGuidePagePath(localizedPath);
        }
      }
    });
  }, [userLocale, unlocalizedSlug]);

  return guidePathPath;
};
